import { Grid } from 'grommet'

export default Grid
